var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},_vm._l((5),function(i){return _c('pdf',{key:i,staticStyle:{"height":"100%"},attrs:{"src":"https://www.dcm.co.th/wp-content/uploads/2021/12/InformationSecurityPolicy.dmeetsdocx.pdf","page":i}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }